import inView from 'in-view';

export const stats = () => {
  inView('.stats__card').on('enter', function (el, i) {
    el.style.animationName = 'fadeIn';
    el.style.animationDuration = '2s';

    setTimeout(() => {
      el.style.opacity = 1;
    }, 2000);
  });
};
